import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//! debug
import { useState } from "react";
import {
  AnimatePresence,
  Button,
  H5,
  SizableText,
  Stack,
  Tabs,
  XStack,
  YStack,
  styled
} from "tamagui";
const demos = ["background", "underline"];
const demosTitle = {
  background: "Background Indicator",
  underline: "Underline Indicator"
};
const TabsAdvancedDemo = () => {
  const [demoIndex, setDemoIndex] = useState(0);
  const demo = demos[demoIndex];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    demo === "underline" ? /* @__PURE__ */ jsx(TabsAdvancedUnderline, {}) : /* @__PURE__ */ jsx(TabsAdvancedBackground, {}),
    /* @__PURE__ */ jsx(
      XStack,
      {
        alignItems: "center",
        space: true,
        position: "absolute",
        bottom: "$3",
        left: "$4",
        $xxs: { display: "none" },
        children: /* @__PURE__ */ jsx(Button, { size: "$2", onPress: () => setDemoIndex((x) => (x + 1) % demos.length), children: demosTitle[demo] })
      }
    )
  ] });
};
const TabsAdvancedBackground = () => {
  const [tabState, setTabState] = useState({
    activeAt: null,
    currentTab: "tab1",
    intentAt: null,
    prevActiveAt: null
  });
  const setCurrentTab = (currentTab2) => setTabState({ ...tabState, currentTab: currentTab2 });
  const setIntentIndicator = (intentAt2) => setTabState({ ...tabState, intentAt: intentAt2 });
  const setActiveIndicator = (activeAt2) => setTabState({ ...tabState, prevActiveAt: tabState.activeAt, activeAt: activeAt2 });
  const { activeAt, intentAt, prevActiveAt, currentTab } = tabState;
  const direction = (() => {
    if (!activeAt || !prevActiveAt || activeAt.x === prevActiveAt.x) {
      return 0;
    }
    return activeAt.x > prevActiveAt.x ? -1 : 1;
  })();
  const enterVariant = direction === 1 ? "isLeft" : direction === -1 ? "isRight" : "defaultFade";
  const exitVariant = direction === 1 ? "isRight" : direction === -1 ? "isLeft" : "defaultFade";
  const handleOnInteraction = (type, layout) => {
    if (type === "select") {
      setActiveIndicator(layout);
    } else {
      setIntentIndicator(layout);
    }
  };
  return /* @__PURE__ */ jsxs(
    Tabs,
    {
      value: currentTab,
      onValueChange: setCurrentTab,
      orientation: "horizontal",
      size: "$4",
      padding: "$2",
      height: 150,
      flexDirection: "column",
      activationMode: "manual",
      backgroundColor: "$background",
      borderRadius: "$4",
      position: "relative",
      children: [
        /* @__PURE__ */ jsxs(YStack, { children: [
          /* @__PURE__ */ jsx(AnimatePresence, { children: intentAt && /* @__PURE__ */ jsx(
            TabsRovingIndicator,
            {
              borderRadius: "$4",
              width: intentAt.width,
              height: intentAt.height,
              x: intentAt.x,
              y: intentAt.y
            }
          ) }),
          /* @__PURE__ */ jsx(AnimatePresence, { children: activeAt && /* @__PURE__ */ jsx(
            TabsRovingIndicator,
            {
              borderRadius: "$4",
              theme: "active",
              width: activeAt.width,
              height: activeAt.height,
              x: activeAt.x,
              y: activeAt.y
            }
          ) }),
          /* @__PURE__ */ jsxs(
            Tabs.List,
            {
              disablePassBorderRadius: true,
              loop: false,
              "aria-label": "Manage your account",
              space: "$2",
              backgroundColor: "transparent",
              children: [
                /* @__PURE__ */ jsx(Tabs.Tab, { unstyled: true, value: "tab1", onInteraction: handleOnInteraction, children: /* @__PURE__ */ jsx(SizableText, { children: "Profile" }) }),
                /* @__PURE__ */ jsx(Tabs.Tab, { unstyled: true, value: "tab2", onInteraction: handleOnInteraction, children: /* @__PURE__ */ jsx(SizableText, { children: "Connections" }) }),
                /* @__PURE__ */ jsx(Tabs.Tab, { unstyled: true, value: "tab3", onInteraction: handleOnInteraction, children: /* @__PURE__ */ jsx(SizableText, { children: "Notifications" }) })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          AnimatePresence,
          {
            exitBeforeEnter: true,
            enterVariant,
            exitVariant,
            children: /* @__PURE__ */ jsx(AnimatedYStack, { animation: "100ms", x: 0, opacity: 1, flex: 1, children: /* @__PURE__ */ jsx(Tabs.Content, { value: currentTab, forceMount: true, flex: 1, justifyContent: "center", children: /* @__PURE__ */ jsx(H5, { textAlign: "center", children: currentTab }) }) }, currentTab)
          }
        )
      ]
    }
  );
};
const TabsAdvancedUnderline = () => {
  const [tabState, setTabState] = useState({
    activeAt: null,
    currentTab: "tab1",
    intentAt: null,
    prevActiveAt: null
  });
  const setCurrentTab = (currentTab2) => setTabState({ ...tabState, currentTab: currentTab2 });
  const setIntentIndicator = (intentAt2) => setTabState({ ...tabState, intentAt: intentAt2 });
  const setActiveIndicator = (activeAt2) => setTabState({ ...tabState, prevActiveAt: tabState.activeAt, activeAt: activeAt2 });
  const { activeAt, intentAt, prevActiveAt, currentTab } = tabState;
  const direction = (() => {
    if (!activeAt || !prevActiveAt || activeAt.x === prevActiveAt.x) {
      return 0;
    }
    return activeAt.x > prevActiveAt.x ? -1 : 1;
  })();
  const enterVariant = direction === 1 ? "isLeft" : direction === -1 ? "isRight" : "defaultFade";
  const exitVariant = direction === 1 ? "isRight" : direction === -1 ? "isLeft" : "defaultFade";
  const handleOnInteraction = (type, layout) => {
    if (type === "select") {
      setActiveIndicator(layout);
    } else {
      setIntentIndicator(layout);
    }
  };
  return /* @__PURE__ */ jsxs(
    Tabs,
    {
      value: currentTab,
      onValueChange: setCurrentTab,
      orientation: "horizontal",
      size: "$4",
      height: 150,
      flexDirection: "column",
      activationMode: "manual",
      backgroundColor: "$background",
      borderRadius: "$4",
      children: [
        /* @__PURE__ */ jsxs(YStack, { children: [
          /* @__PURE__ */ jsx(AnimatePresence, { children: intentAt && /* @__PURE__ */ jsx(
            TabsRovingIndicator,
            {
              width: intentAt.width,
              height: "$0.5",
              x: intentAt.x,
              bottom: 0
            }
          ) }),
          /* @__PURE__ */ jsx(AnimatePresence, { children: activeAt && /* @__PURE__ */ jsx(
            TabsRovingIndicator,
            {
              theme: "active",
              active: true,
              width: activeAt.width,
              height: "$0.5",
              x: activeAt.x,
              bottom: 0
            }
          ) }),
          /* @__PURE__ */ jsxs(
            Tabs.List,
            {
              disablePassBorderRadius: true,
              loop: false,
              "aria-label": "Manage your account",
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              paddingBottom: "$1.5",
              borderColor: "$color3",
              borderBottomWidth: "$0.5",
              backgroundColor: "transparent",
              children: [
                /* @__PURE__ */ jsx(
                  Tabs.Tab,
                  {
                    unstyled: true,
                    padding: "$5",
                    value: "tab1",
                    onInteraction: handleOnInteraction,
                    children: /* @__PURE__ */ jsx(SizableText, { children: "Profile" })
                  }
                ),
                /* @__PURE__ */ jsx(
                  Tabs.Tab,
                  {
                    unstyled: true,
                    padding: "$5",
                    value: "tab2",
                    onInteraction: handleOnInteraction,
                    children: /* @__PURE__ */ jsx(SizableText, { children: "Connections" })
                  }
                ),
                /* @__PURE__ */ jsx(
                  Tabs.Tab,
                  {
                    unstyled: true,
                    padding: "$5",
                    value: "tab3",
                    onInteraction: handleOnInteraction,
                    children: /* @__PURE__ */ jsx(SizableText, { children: "Notifications" })
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          AnimatePresence,
          {
            exitBeforeEnter: true,
            enterVariant,
            exitVariant,
            children: /* @__PURE__ */ jsx(AnimatedYStack, { animation: "100ms", x: 0, opacity: 1, flex: 1, children: /* @__PURE__ */ jsx(Tabs.Content, { value: currentTab, forceMount: true, flex: 1, justifyContent: "center", children: /* @__PURE__ */ jsx(H5, { textAlign: "center", children: currentTab }) }) }, currentTab)
          }
        )
      ]
    }
  );
};
const TabsRovingIndicator = ({ active, ...props }) => {
  return /* @__PURE__ */ jsx(
    Stack,
    {
      position: "absolute",
      backgroundColor: "$color5",
      opacity: 0.7,
      animation: "100ms",
      enterStyle: {
        opacity: 0
      },
      exitStyle: {
        opacity: 0
      },
      ...active && {
        backgroundColor: "$color8",
        opacity: 0.6
      },
      ...props
    }
  );
};
const AnimatedYStack = styled(YStack, {
  variants: {
    isLeft: { true: { x: -25, opacity: 0 } },
    isRight: { true: { x: 25, opacity: 0 } },
    defaultFade: { true: { opacity: 0 } }
  }
});
export {
  TabsAdvancedDemo
};
//# sourceMappingURL=TabsAdvancedDemo.js.map
